import SignupLoginPopup from "./SignupLoginPopup";

export default SignupLoginPopup;